import { useToast } from "native-base";
import React, { useEffect, useState } from "react";
import {
  Dimensions,
  Platform,
  StyleSheet,
  TouchableHighlight,
  View,
} from "react-native";
import Theme from "../argon-ui/Theme";
import { translate } from "../locales/translate";
import ModalBase from "../nativeBase-ui/ModalBase";
import Text from "./TextFont";
import BuildingInfo from "../viewModels/BuildingInfo";
import QRCodeItem from "./QRCodeItem";
import { sliceNumberFromString } from "../hooks/sliceNumberFromString";
import FontAwesomeIcon from "./FontAwesomeIcon";
import { faCopy } from "../../assets/consts/faCharCodes";
import * as Clipboard from "expo-clipboard";
import ToastAlert from "../nativeBase-ui/ToastAlert";
import DividerWithText from "./DividerWithText";
import { BRANDING } from "../../assets/consts";
import { getDir, getIsRTL } from "../util";
const CODE_PREFIX = BRANDING.CODE_PREFIX;
const width = Dimensions.get("window").width;
type Props = {
  showQRCodeJoinBuilding: boolean;
  isKioskMode: boolean;
  buildingInfo: BuildingInfo;
  hideModal: () => void;
};

const QRCodeJoinBuilding = (props: Props) => {
  const { showQRCodeJoinBuilding, hideModal, isKioskMode } = props;
  const [buildingInfo, setBuildingInfo] = useState<BuildingInfo | null>(null);
  const toast = useToast();
  useEffect(() => {
    if (props.buildingInfo) {
      setBuildingInfo(props.buildingInfo);
    }
  }, []);
  const handlerCopyClipboard = async (code: string | undefined) => {
    if (code) {
      const clipboard = await Clipboard.setStringAsync(code);
      if (clipboard) {
        const toastMessage = {
          title: translate(`building.QRCode.copySuccess`),
          variant: "top-accent",
          status: "success",
        };
        toast.show({
          duration: 1500,
          render: () => {
            return <ToastAlert {...toastMessage} />;
          },
        });
      }
    }
  };
  return (
    <ModalBase
      style={{
        // maxWidth: isKioskMode ? width / 2 : width,
        alignSelf: "center",
        direction: getDir(),
      }}
      header={translate("building.QRCode.modalTitle")}
      isOpen={showQRCodeJoinBuilding}
      onClose={() => hideModal()}
    >
      <View style={{ padding: 8, marginTop: 5 }}>
        <Text
          style={{
            fontSize: 12,
            color: Theme.COLORS.MUTED,
            marginBottom: 10,
          }}
        >
          {translate("building.QRCode.QRCodeDesc")}
        </Text>
        {/* === QR Code === */}
        <View
          style={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <QRCodeItem
            value={buildingInfo?.code}
            // name={buildingInfo?.buildingName}
            size={isKioskMode ? width / 5 : width / 3}
            containerStyle={[
              styles.QRCodeContainer,
              {
                shadowColor: Theme.COLORS.MUTED,
                shadowOffset: {
                  width: 0,
                  height: 3,
                },
                shadowOpacity: 0.4,
                shadowRadius: 10,
                elevation: 4,
              },
            ]}
          />
        </View>
        {/* === Or Register code === */}
        <DividerWithText label={translate("building.QRCode.orRegisterDesc")} />
        {/* === register code === */}
        <TouchableHighlight
          onPress={() => handlerCopyClipboard(buildingInfo?.code)}
          underlayColor="transparent"
          style={[styles.QRCodeContainer, { padding: 5, height: 45 }]}
        >
          <View
            style={{
              flex: 1,
              width: "100%",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              padding: 5,
            }}
          >
            <FontAwesomeIcon
              icon={faCopy}
              size={14}
              color={Theme.COLORS.MUTED}
            />
            <View
              style={[
                {
                  flex: 1,
                  width: "100%",
                  flexDirection: getIsRTL() ? "row" : "row-reverse",
                  justifyContent: "center",
                },
                Platform.OS === "web"
                  ? { paddingLeft: 15 }
                  : { paddingRight: 15 },
              ]}
            >
              <Text
                style={[
                  // styles.QRCodeContainer,
                  {
                    fontFamily: "sans-serif",
                    paddingHorizontal: 5,
                    textAlign: "center",
                    // fontWeight: "bold",
                    fontSize: 16,
                  },
                ]}
              >
                {/* {buildingInfo?.code} */}
                {buildingInfo?.code &&
                  sliceNumberFromString(buildingInfo?.code).map(
                    (text, index) => {
                      // === Text Section ===
                      if (index === 0) {
                        return text.toUpperCase();
                      }
                      // === Number Section ===
                      return " - " + text;
                    }
                  )}
              </Text>
              <Text style={{ color: Theme.COLORS.MUTED, fontSize: 12 }}>
                {" "}
                {CODE_PREFIX.toUpperCase() + " -"}
              </Text>
            </View>
          </View>
        </TouchableHighlight>
      </View>
    </ModalBase>
  );
};
const styles = StyleSheet.create({
  QRCodeContainer: {
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    backgroundColor: Theme.COLORS.LIGHT_MAIN,
    borderColor: Theme.COLORS.BLOCK,
    borderWidth: 1,
    padding: 10,
    borderRadius: 10,
  },
});
export default QRCodeJoinBuilding;
